import { Dispatch, SetStateAction } from "react";

import {
  ChoiceComboBox,
  IComboBoxOption,
  SearchBox,
  Stack,
  useTheme
} from "@bps/fluent-ui";
import { useDeploymentRings } from "@libs/api/gateways/field/field-ops-gateway.hooks";

export interface DeployManagementFilterValues {
  search: string;
  deploymentRingId: string;
}

export interface DeployManagementFilterState
  extends DeployManagementFilterValues {
  setSearch: Dispatch<SetStateAction<string>>;
  setRingId: Dispatch<SetStateAction<string>>;
}

export const DeployManagementFilters: React.FC<DeployManagementFilterState> = ({
  search,
  setSearch,
  deploymentRingId,
  setRingId
}) => {
  const theme = useTheme();

  const { data } = useDeploymentRings();

  // A ring must be picked before the screen loads, so there is no "All rings" option.
  const deploymentRings: IComboBoxOption[] = (data ?? [])
    .slice()
    .sort((a, b) => a.displayName.localeCompare(b.displayName))
    .map(ring => ({ key: ring.id, text: ring.displayName }));

  return (
    <Stack
      horizontal
      wrap
      verticalAlign="end"
      tokens={{ childrenGap: theme.spacing.m }}
    >
      <ChoiceComboBox
        data-name-for-input="ringFilter"
        label="Deployment ring"
        placeholder="Select a ring to load tenants"
        required
        autoComplete="on"
        dynamicOptions
        selectedKey={deploymentRingId}
        options={deploymentRings}
        onChange={(_e, options) => setRingId(options.key ?? "")}
        styles={{ root: { width: 220 }, callout: { height: 400 } }}
      />
      <SearchBox
        placeholder="Filter by tenant name or ID"
        value={search}
        onChange={(_e, newValue) => setSearch(newValue ?? "")}
        styles={{ root: { width: 320, margin: "0 0 8px 0" } }}
      />
    </Stack>
  );
};
